export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
